const TRUSTED_ORIGINS_REGEX = [
  /^\/.*$/, // Relative URLs
  // Nested subdomains of suicidegirls.com (includes staging)
  /^https:\/\/(?:[^.]+\.)*suicidegirls\.com(?:[/?#].*)?$/,
  // Dev subdomains
  /^https:\/\/(?:[^.]*\.)?local\.suicidegirls\.com:\d+(?:[/?#].*)?$/,
];

export default (url) => TRUSTED_ORIGINS_REGEX.some((regex) => regex.test(url));
